<template>
<div>
  <div class="flex justify-center text-3xl mt-12">
    <span> If you could <b> Do </b> anything, <br> what would you <b> To-Do</b>?</span>
  </div>
  <div class="flex justify-center" style="margin-top:0rem;">
    <img :src="image" class="w-1/2"/>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import { auth } from "@/firebaseConfig";
import image from "../assets/todoulogo.png";

export default {
  name: 'HomeView',
  components: {
  },
  data() {
    return {
      image: image
    };
  },
  beforeCreate: function() {
    if(auth.currentUser){
      this.$router.replace("/todos")
    }
  }
}
</script>
